import moment from 'moment'
import React from 'react'
import {
  Bar,
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import LegendComponent from '../../../common/legend/Legend'
import { i18n } from '../../index'
import css from './incentiveSales.css'
import type { DailySalesIncentiveReport } from './types'
type Unit = '\u20AC' | 'kpl'
type Props = {
  month: moment.Moment
  data: Array<DailySalesIncentiveReport>
}

const STROKES = {
  ACTUAL: '#78A22F',
  TARGET: '#F7AC01',
}

class IncentiveSalesGraph extends React.Component<Props, {}> {
  render() {
    const { month, data } = this.props
    const unit = '€'
    return (
      <div>
        <h4>
          {i18n.t('reporting.incentiveSales')}: {moment(month).format('MMMM YYYY')}
        </h4>
        <div className={css.chart}>
          <div className={css.graphButtonGroup}></div>
          <div>
            <ResponsiveContainer width='100%' height={300}>
              <ComposedChart
                margin={{
                  top: 30,
                  right: 10,
                  bottom: 10,
                  left: 10,
                }}
                data={data}
              >
                <CartesianGrid />

                <XAxis
                  dataKey={'date'}
                  interval={0}
                  tickFormatter={(item) => moment(item).format('D')}
                  axisLine={{
                    stroke: '#ccc',
                    strokeWidth: 1,
                  }}
                  tickSize={0}
                  tickMargin={10}
                  tick={{
                    fontSize: 12,
                  }}
                />
                <YAxis
                  padding={{
                    top: 0,
                  }}
                  axisLine={{
                    stroke: '#ccc',
                    strokeWidth: 1,
                  }}
                  tickCount={6}
                  tickSize={0}
                  tickMargin={10}
                  tick={{
                    fontSize: 12,
                  }}
                >
                  <Label value={unit} position='top' offset={15} />
                </YAxis>

                <Tooltip />

                <Legend content={<LegendComponent />} />

                <Line
                  type='linear'
                  dataKey={'euroTarget'}
                  dot={false}
                  unit={unit}
                  name={i18n.t('reporting.target')}
                  legendType='line'
                  strokeWidth={3}
                  stroke={STROKES.TARGET}
                />

                <Bar
                  dataKey={'euroActual'}
                  unit={unit}
                  name={i18n.t('reporting.actual')?.toString()}
                  barSize={10}
                  fill={STROKES.ACTUAL}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    )
  }
}

export default IncentiveSalesGraph
